<template>

	<div>
		<div :id="maxscrollTop?'commonGoTopNav':''">
			<div class="commonNavBox breadcrumb">
				<el-breadcrumb separator-class="el-icon-arrow-right">
				  <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
				  <el-breadcrumb-item :to="{ path: '/infomation',query:{id:catid}}">媒体中心</el-breadcrumb-item>
				  <el-breadcrumb-item :to="{ path: '/news',query:{id:catid} }" v-if="type==2">行业新闻</el-breadcrumb-item>
					<el-breadcrumb-item :to="{ path: '/videoCenter',query:{id:catid} }" v-else>糠宝瑞资讯</el-breadcrumb-item>
				  <el-breadcrumb-item >新闻详情</el-breadcrumb-item>
				</el-breadcrumb>
			</div>
		</div>

		<div class="newsDetailBox">

			<div class=" newsTitleBox">
				<h2>{{detail.title}}</h2>
				<span>{{detail.update_time}}</span>
			</div>
			<p class="newsContern" v-html="detail.content"></p>
		</div>
	</div>
</template>
<style scoped>
</style>
<script>
import * as axios from '../../src/axios/api.js'
import imgUrl from '../../src/utils/imgUrl.js'
import * as timeData from '../../src/utils/DataUtils.js'
export default{
	data(){
		return{
			maxscrollTop:false,
			detail:{},
			catid:'',
			type:'',
		}
	},
	created() {
		var id=this.$route.query.id;
		var catid=this.$route.query.catid
		this.catid=catid;
		this.type=this.$route.query.type
		// 调用查询新闻列表接口
		this.getNewsDetailList(id,catid);
	},
    mounted() {
		window.addEventListener('scroll', this.handleScroll)
    },
	methods:{
		getNewsDetailList(id,catid){
			axios.get('/api/news/detail',{id:id,catid:catid}).then(res => {
				if(res.code==1){
					this.detail=res.data
					this.detail.update_time=timeData.formatDate(this.detail.inputtime);
				}
			});
		},
		 handleScroll () {
		   var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
		   if(scrollTop > 464){
			   this.maxscrollTop = true
		   }else{
			   this.maxscrollTop = false
		   }
		 },
	}
}
</script>

